import { render, staticRenderFns } from "./vipLevelConfig.vue?vue&type=template&id=0c64b211&scoped=true"
import script from "./vipLevelConfig.vue?vue&type=script&lang=js"
export * from "./vipLevelConfig.vue?vue&type=script&lang=js"
import style0 from "./vipLevelConfig.vue?vue&type=style&index=0&id=0c64b211&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c64b211",
  null
  
)

component.options.__file = "vipLevelConfig.vue"
export default component.exports